import { Injectable } from '@angular/core';
import { Observable, zip } from 'rxjs';
import { map } from 'rxjs/operators';

import { BlobFileApiModel } from '@app/api/api-models';
import { UploadFileService } from '@app/shared/services/upload-file.service';
import { HttpClientService } from '@app/api/api-services/http-client.service';

@Injectable()
export class DocsService {
  public apiUrl = 'users';
  public profileInfo: any;
  public userRole: number;

  constructor(private http: HttpClientService, private uploadFileService: UploadFileService) {}

  public uploadAllDocs(filesToUpload: File[], userId: string): Observable<any> {
    const sentFiles = [];

    filesToUpload.forEach((file) => {
      sentFiles.push(this.uploadDocuments(file, userId));
    });

    return zip(...sentFiles);
  }

  public downloadDoc(docId: string): Observable<BlobFileApiModel> {
    return this.http
      .get<BlobFileApiModel>(`documents/download/${docId}`)
      .pipe(map((x) => new BlobFileApiModel().deserialize(x)));
  }

  public uploadDocuments(file: File, userId: string): Observable<void> {
    const payload = new FormData();
    this.uploadFileService.append(payload, file);

    return this.http.post<void>(`documents/upload?userId=${userId}`, payload);
  }
}
